import { render, staticRenderFns } from "./move-to-group-dialog.vue?vue&type=template&id=200d2864&scoped=true"
import script from "./move-to-group-dialog.vue?vue&type=script&lang=js"
export * from "./move-to-group-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d2864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200d2864')) {
      api.createRecord('200d2864', component.options)
    } else {
      api.reload('200d2864', component.options)
    }
    module.hot.accept("./move-to-group-dialog.vue?vue&type=template&id=200d2864&scoped=true", function () {
      api.rerender('200d2864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/move-to-group-dialog.vue"
export default component.exports